import React, { useState, useEffect, useContext, useRef } from "react";
import { Message_data } from "../context/context";
import { db, db2, auth } from "../firebase-config";
import { gapi } from "gapi-script";
import {
  doc,
  getDoc,
  addDoc,
  setDoc,
  deleteDoc,
  updateDoc,
  getDocs,
  collection,
  onSnapshot,
  query,
  serverTimestamp,
  where,
  orderBy,
  writeBatch,
} from "firebase/firestore";
import AccordionList from "./AccordionList";
import JukeboxRequests from "./Requests/JukeboxRequests";
import VideoPlayback4 from "./VideoPlayback4";
import Player from "./AudioMusicPlayer/Player";
// import Player2 from "./AudioMusicPlayer/Player2";
// import Player3 from "./AudioMusicPlayer/Player3";
import Player4 from "./AudioMusicPlayer/Player4";
import MoodDashboard from "./MoodDashboard";
import "../styles/Chat.scss";
import useVideos from "../hooks/useVideos";

export const AutoPlay = ({ userObj, clientObj }) => {
  const [jukebox, setJukebox] = useState([]);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const userJukeboxRef = collection(
    db,
    "users",
    auth.currentUser.uid,
    "playlists"
  );
  const { message, setMessage } = useContext(Message_data);
  const [inputFocus, setInputFocus] = useState(false);
  const [originalJukebox, setOriginalJukebox] = useState([]);
  const [count, setCount] = useState(originalJukebox.length);
  const [isOpen, setIsOpen] = useState(false);
  const [displayNameOpen, setDisplayNameOpen] = useState(false);
  const [requestedTrack, setRequestedTrack] = useState({});
  const [DJChatId, setDJChatId] = useState("5fD03BaD7INyhJMne2gfLdPAKbQ2");
  const [messages, setMessages] = useState([]);
  const [avatars, setAvatars] = useState({});
  const [groupedTracks, setGroupedTracks] = useState([]);
  const [newDisplayName, setNewDisplayName] = useState("");
  const [jukeboxUserObj, setJukeboxUserObj] = useState(userObj);
  const [currentRequestDetails, setCurrentRequestDetails] = useState({});
  const [siteConfig, setSiteConfig] = useState({});
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videos, search] = useVideos("react js custom hooks");
  const [draggingItem, setDraggingItem] = useState(null);
  const [showVideoPlayback, setShowVideoPlayback] = useState(false);
  const [showVideoPlayback2, setShowVideoPlayback2] = useState(false);
  const [showAudioPlayback, setShowAudioPlayback] = useState(false);

  const [trackId, setTrackId] = useState(null);
  const [showTrackForm, setShowTrackForm] = useState(false);
  const [genre, setGenre] = useState(null);
  const [artist, setArtist] = useState(null);
  const [track, setTrack] = useState(null);
  const [url, setUrl] = useState(null);
  const [youTubeId, setYouTubeId] = useState(null);
  const [currentTrack, setCurrentTrack] = useState({});
  const [coverart, setCoverart] = useState(null);
  const [videoId, setVideoId] = useState(null);
  const [currentPlayingTrackIndex, setCurrentPlayingTrackIndex] =
    useState(null);
  const [nextPlayingTrackIndex, setNextPlayingTrackIndex] = useState(null);
  const [currentDeck, setCurrentDeck] = useState(1);
  const [insertTrack, setInsertTrack] = useState(null);
  const [lastRequest, setLastRequest] = useState({});

  const [showMP3Playback, setShowMP3Playback] = useState(false);

  const [trackList, setTrackList] = useState([]);
  const [stopAudio, setStopAudio] = useState(false);
  const [playlistId, setPlaylistId] = useState(null);
  const [playlistName, setPlaylistName] = useState(null);
  const [currentSong, setCurrentSong] = useState(null);
  const [nextSong, setNextSong] = useState(null);
  const [previousCurrentSongId, setPreviousCurrentSongId] = useState(null);
  
  // New state for alphabetical toggle and search
  const [isAlphabetical, setIsAlphabetical] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(-1);
  const searchInputRef = useRef(null);
  const trackRefs = useRef({});

  const [defaultPlaylist, setDefaultPlaylist] = useState("");
  const [accountName, setAccountName] = useState("");
  const [crossfadeDuration, setCrossfadeDuration] = useState("");
  const [jukeboxList, setJukeboxList] = useState([]);
  const [newPending, setNewPending] = useState([]);
  const [oldPending, setOldPending] = useState([]);
  const [upObj, setUpObj] = useState({});
  const [downObj, setDownObj] = useState({});
  const [lastVoteUpdate, setLastVoteUpdate] = useState(new Date());

  // const calendarID = process.env.REACT_APP_CALENDAR_ID
  const apiKey = "AIzaSyAaGVGPCShsFPzcelLw5slKBV5Wa8FhYHc"; //process.env.REACT_APP_GOOGLE_API_KEY
  // const accessToken = process.env.REACT_APP_GOOGLE_ACCESS_TOKEN

  const getYoutubesx = (trackquery) => {
    gapi.client.setApiKey("AIzaSyAaGVGPCShsFPzcelLw5slKBV5Wa8FhYHc");
    gapi.client.load("youtube", "v3", function () {
      makeRequest(trackquery);
    });
  };

  const makeRequest = (q) => {
    let request = gapi.client.youtube.search.list({
      q: q,
      part: "snippet",
      maxResults: 10,
    });
    request.execute(function (response) {
      var srchItems = response.result.items;
      srchItems.forEach((item) => {
        // console.log("item", item);
        // vidTitle = item.snippet.title;
        // vidThumburl =  item.snippet.thumbnails.default.url;
        // vidURL = 'https://youtube.com/watch?v='+item.id.videoId;
        // vidThumbimg = '<pre><a href="'+vidURL+'"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:204px;height:128px"></a></pre>';
        // $('#results').append('<pre>' + vidTitle + vidThumbimg +   '</pre>');
      });
    });
  };

  useEffect(() => {
    const playerControlData = async () => {
      if (message) {
        const data = JSON.parse(message);
        if (data.insertTrack) {
          const insertTrack = JSON.parse(data.insertTrack);
          // compare ids not youTuneId local mp3s don't have youTubeIds....duh...!!!!
          // console.log("insertTrack", insertTrack);

          if (lastRequest.id !== insertTrack.id) {
            // insert it after current playing track
            // useing currentPlayingTrackIndex search along the jukebox array looking for the next item that is not queued from outside
            let queueSize = 1;
            const jukeboxSearchRange = jukebox.slice(
              currentPlayingTrackIndex + 1
            );
            const i = jukeboxSearchRange.findIndex(
              (item) => item.queued !== true
            );
            if (i !== -1) {
              queueSize = queueSize + i;
            }

            insertTrack.queued = true;
            insertTrack.ordinal = currentPlayingTrackIndex + queueSize;
            const p = jukebox;
            p.splice(currentPlayingTrackIndex + queueSize, 0, insertTrack);
            // get ride of queued tracks that have already been played
            let ii = 0;
            const removePending = [];
            while (ii < currentPlayingTrackIndex + 1) {
              p[ii].queued = false;
              ii++;
            }
            // console.log("update next track");
            // console.log("queueSize", queueSize);
            // console.log("jukebox", p);
            // creating pending from serching queued = true in p
            const pending = p.map((item) => {
              if (item.queued === true) return item;
            });
            setNewPending(pending);
            setJukebox(p);
            setLastRequest(insertTrack);
            forceUpdate();
          }
        }
        if (data.skipTrack) {
          // find this track in the jukebox list and mark it as skip.true
          const skipTrack = JSON.parse(data.skipTrack);
          // console.log("*&* skippable default track", skipTrack);
          // console.log("*&* jukebox", jukebox);
          const idx = jukebox.findIndex((item) => item.id === skipTrack.id);
          if (idx !== -1) {
            // console.log("*&* marked this track to as skip:true");
            // at this point the next track should be immediately updated so its seen on the users screens
            const jb = jukebox;
            jb[idx].skip = true;
            // since this is now skipped the votes for it need to be purged
            setOldPending(jb[idx]);
            setNextSong(jb[idx + 1]);
            setJukebox(jb);
            forceUpdate();
          }
        }
        if (data.delTrack) {
          // find this track in the jukebox list and delete it, as long as its it marked as a queued
          const delTrack = JSON.parse(data.delTrack);
          // console.log("delTrack track", delTrack);
          const idx = jukebox.findIndex(
            (item) => item.id === delTrack.id && item.ordinal > 0
          );
          if (idx !== -1) {
            // console.log("queued track to delete is", jukebox[idx]);
            const jb = jukebox;
            jb.splice(idx, 1);
            setJukebox(jb);
            forceUpdate();
          }
        }
      }
    };
    playerControlData();
  }, [
    currentPlayingTrackIndex,
    forceUpdate,
    jukebox,
    lastRequest.id,
    message,
    setMessage,
  ]);

  const getSiteConfig = () => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db2, `siteconfig`));
      querySnapshot.forEach((doc) => {
        setSiteConfig({
          siteid: doc.data().siteid,
          trackURL: doc.data().trackURL,
          initialTrack: [
            {
              url: doc.data().trackURL,
              title: doc.data().trackTitle,
              artist: doc.data().trackArtist,
              releasePath: doc.data().trackReleasePath,
              tags: doc.data().trackTags,
              coverImage: doc.data().trackCoverImage,
              userplaylist: false,
            },
          ],
        });
      });
    };
    fetchData().catch(console.error);
  };

  useEffect(() => {
    const initAutoplay = async () => {
      getSiteConfig();
      const queryMessages = query(userJukeboxRef);

      const unsuscribe = onSnapshot(queryMessages, (snapshot) => {
        let jukeboxList = [];
        snapshot.forEach((doc) => {
          jukeboxList.push({ ...doc.data(), id: doc.id });
        });
        setJukeboxList(jukeboxList);
      });

      const docRef = doc(db, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setAccountName(docSnap.data().muuzboxAccountName.toLowerCase());
        setCrossfadeDuration(docSnap.data().muuzboxCrossFadeDuration);
      }

      return () => unsuscribe();
    };

    initAutoplay();
  }, []);

  // Function to fetch latest votes
  const fetchLatestVotes = React.useCallback(async () => {
    try {
      const votesRef = collection(
        db,
        "users",
        auth.currentUser.uid,
        "pendingListVotes"
      );

      const querySnapshot = await getDocs(votesRef);
      const voteUpObj = {};
      const voteDownObj = {};

      querySnapshot.forEach((doc) => {
        const voteData = doc.data();
        if (voteData.votedAt !== null) {
          const trackId = voteData.trackId;
          if (voteData.voted === "up") {
            voteUpObj[trackId] = (voteUpObj[trackId] || 0) + 1;
          } else {
            voteDownObj[trackId] = (voteDownObj[trackId] || 0) + 1;
          }
        }
      });

      setUpObj(voteUpObj);
      setDownObj(voteDownObj);
      setLastVoteUpdate(new Date());
      forceUpdate();
    } catch (error) {
      console.error("Error fetching votes:", error);
    }
  }, [forceUpdate]);

  // Fetch votes for tracks with real-time updates and periodic refresh
  useEffect(() => {
    const votesRef = collection(
      db,
      "users",
      auth.currentUser.uid,
      "pendingListVotes"
    );

    // Initial fetch
    fetchLatestVotes();

    // Set up real-time listener for immediate updates
    const voteUpObj = {};
    const voteDownObj = {};
    const unsubscribe = onSnapshot(votesRef, (querySnapshot) => {
      let changes = querySnapshot.docChanges();
      for (let change of changes) {
        if (change.doc.data().votedAt !== null) {
          let trackId = change.doc.data().trackId;
          if (change.doc.data().voted === "up") {
            if (voteUpObj[trackId]) {
              let vote = voteUpObj[trackId];
              vote++;
              voteUpObj[trackId] = vote;
            } else {
              voteUpObj[trackId] = 1;
            }
          } else {
            if (voteDownObj[trackId]) {
              let vote = voteDownObj[trackId];
              vote++;
              voteDownObj[trackId] = vote;
            } else {
              voteDownObj[trackId] = 1;
            }
          }
        }
      }
      setTimeout(() => {
        setDownObj(voteDownObj);
        setUpObj(voteUpObj);
      }, 100);
    });

    // Set up 1-minute interval for vote refresh
    const intervalId = setInterval(() => {
      // console.log("Refreshing votes...");
      fetchLatestVotes();
    }, 60000); // 60000 ms = 1 minute

    return () => {
      unsubscribe();
      clearInterval(intervalId);
    };
  }, [fetchLatestVotes]);

  useEffect(() => {
    setJukeboxUserObj(userObj);
  }, [userObj]);

  useEffect(() => {
    setSelectedVideo(videos[0]);
  }, [videos]);

  useEffect(() => {
    // update pending collection for this user with newPending
    if (newPending.length > 0) {
      newPending.forEach((item) => {
        console.log("item", item);
        if (item) {
          const ref = doc(
            db,
            `users`,
            auth.currentUser.uid,
            "pendingList",
            item.id
          );
          setDoc(ref, {
            id: item.id || "",
            artist: item.artist || "",
            track: item.track || "",
            url: item.url,
            genre: item.genre || "",
            coverart: item.coverart || "",
            youTubeId: item.youTubeId || "",
            requester: item.requester || "",
            uid: item.uid || "",
            updatedAt: serverTimestamp(),
            ordinal: item.ordinal || "",
          });
        }
      });
    }
  }, [newPending]);

  useEffect(() => {
    const init = async () => {
      // update pending collection for this user with newPending
      const plv = [];
      // console.log("this hsould be an array: oldPending", oldPending);
      if (oldPending.length > 0) {
        oldPending.forEach((item) => {
          // console.log("delete item", item);
          if (item) {
            const ref = doc(
              db,
              `users`,
              auth.currentUser.uid,
              "pendingList",
              item.id
            );
            deleteDoc(ref);
            plv.push(item);
          }
        });

        // now get rid of plv
        // console.log("plv", plv);
        // console.log("plv length", plv.length);
        if (plv.length > 0) {
          plv.forEach(async (plvitem) => {
            // console.log("plv item", plvitem);

            const collectionRef = collection(
              db,
              "users",
              auth.currentUser.uid,
              "pendingListVotes"
            );
            const q = query(collectionRef, where("trackId", "==", plvitem.id));

            const querySnapshot = await getDocs(q);
            const batch = writeBatch(db);

            querySnapshot.forEach((doc) => {
              batch.delete(doc.ref);
            });

            await batch.commit();
            // console.log("Documents deleted successfully");
          });
        }
      }
    };
    init();
  }, [oldPending]);

  const createGenreKey = (genre) => {
    if (genre) {
      //take all spacs and non alphnumeric characters out of genre
      let shortGenre = genre.replace(/\s/g, "");
      shortGenre = shortGenre.replace(/[^a-zA-Z0-9]/g, "");
      shortGenre = shortGenre.toLowerCase();
      return shortGenre;
    } else {
      return "none";
    }
  };

  // const groupTracksByGenre = (tracks) => {
  //   const genredtracks = [];
  //   tracks.forEach((item) => {
  //     if (item.genre && item.genre.includes("/")) {
  //       let newGenres = item.genre.split("/");
  //       newGenres.forEach((newitem) => {
  //         genredtracks.push({
  //           coverart: item.coverart,
  //           artist: item.artist,
  //           track: item.track,
  //           genre: newitem,
  //           genrekey: createGenreKey(newitem),
  //         });
  //       });
  //     } else {
  //       item.genrekey = createGenreKey(item.genre);
  //       genredtracks.push(item);
  //     }
  //   });
  //   return genredtracks;
  // };

  const groupTracksByGenre = (tracks) => {
    const genredtracks = [];
    tracks.forEach((item, i) => {
      if (item.genre && item.genre.includes(",")) {
        let newGenres = item.genre.split(",");
        newGenres.forEach((newitem) => {
          genredtracks.push({
            // currentSong: item.currentSong,
            coverart: item.coverart,
            artist: item.artist,
            track: item.track,
            genre: newitem,
            genrekey: createGenreKey(newitem),
            ordinal: i,
            id: item.id,
            youTubeId: item.youTubeId,
            url: item.url,
          });
        });
      } else if (item.genre && item.genre.includes("/")) {
        let newGenres = item.genre.split("/");
        newGenres.forEach((newitem) => {
          genredtracks.push({
            // currentSong: item.currentSong,
            coverart: item.coverart,
            artist: item.artist,
            track: item.track,
            genre: newitem,
            genrekey: createGenreKey(newitem),
            ordinal: i,
            id: item.id,
            youTubeId: item.youTubeId,
            url: item.url,
          });
        });
      } else {
        if (!item.genre) {
          item.genre = "none";
        }
        item.genrekey = createGenreKey(item.genre);
        genredtracks.push(item);
      }
    });
    return genredtracks;
  };

  useEffect(() => {
    const chatsMessgesRef = collection(
      db,
      "users",
      auth.currentUser.uid,
      "djchats",
      DJChatId,
      "messages"
    );
    const queryMessages = query(chatsMessgesRef, orderBy("createdAt"));
    const unsuscribe = onSnapshot(queryMessages, (snapshot) => {
      let messagesx = [];
      let avatars = [];

      snapshot.forEach((doc) => {
        // create an avatar list that can be referred to when the chatlist is rendered
        avatars.push(doc.data().uid);
        messagesx.push(Object.assign({ ...doc.data(), id: doc.id }));
      });

      new Promise(function (resolve, reject) {
        const avatarObj = {};
        const uniq = [...new Set(avatars)];
        let i = 0;
        // search for these uids and the photoURL that goes with them
        uniq.forEach(async (uid) => {
          i++;
          const docRef = doc(db, "users", uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            avatarObj[uid] = {
              displayName: docSnap.data().displayName,
              photoURL: docSnap.data().photoURL,
              email: docSnap.data().email,
            };
          } else {
            // some random image maybe an ai generated icon and displayname
            avatarObj[uid] = {
              displayName: docSnap.data().displayName || "",
              photoURL: docSnap.data().photoURL || "",
            };
          }
        });
        if (i >= uniq.length) resolve(avatarObj);
        else reject();
      })
        .then(function (avatarObj) {
          return new Promise((resolve, reject) => {
            setTimeout(() => resolve(setAvatars(avatarObj)), 300);
          });
        })
        .then(function (result) {
          setMessages(messagesx);
        });
    });
    return () => unsuscribe();
  }, [DJChatId]);

  const arraySearch = (array, keyword) => {
    const searchTerm = keyword.toLowerCase();
    return array.filter((value) => {
      if (!value.track) value.track = value.artist;
      if (!value.artist) value.artist = value.track;
      if (!value.artist && !value.track) return null;
      return (
        value.track.toLowerCase().match(new RegExp(searchTerm, "g")) ||
        value.artist.toLowerCase().match(new RegExp(searchTerm, "g"))
      );
    });
  };

  // Toggle alphabetical sorting
  const toggleAlphabetical = () => {
    setIsAlphabetical(!isAlphabetical);
    if (!isAlphabetical) {
      // Sort alphabetically by track title
      const sorted = [...jukebox].sort((a, b) => {
        const trackA = (a.track || '').toLowerCase();
        const trackB = (b.track || '').toLowerCase();
        return trackA.localeCompare(trackB);
      });
      setJukebox(sorted);
    } else {
      // Restore original order
      setJukebox([...originalJukebox]);
    }
  };

  // Handle search input
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    if (value.trim().length > 0) {
      const results = arraySearch(jukebox, value);
      setSearchResults(results);
      setCurrentSearchIndex(results.length > 0 ? 0 : -1);
      
      // Scroll to first result
      if (results.length > 0) {
        scrollToTrack(results[0].id);
      }
    } else {
      setSearchResults([]);
      setCurrentSearchIndex(-1);
    }
  };

  // Handle Tab key navigation for search results
  const handleSearchKeyDown = (e) => {
    if (e.key === 'Tab' && searchResults.length > 0) {
      e.preventDefault();
      
      const nextIndex = (currentSearchIndex + 1) % searchResults.length;
      setCurrentSearchIndex(nextIndex);
      scrollToTrack(searchResults[nextIndex].id);
    } else if (e.key === 'Escape') {
      // Clear search
      setSearchTerm('');
      setSearchResults([]);
      setCurrentSearchIndex(-1);
      searchInputRef.current?.blur();
    }
  };

  // Scroll to track smoothly
  const scrollToTrack = (trackId) => {
    const element = trackRefs.current[trackId];
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // Add highlight effect using Tailwind classes
      element.classList.add('bg-indigo-500', 'bg-opacity-30', 'transition-all', 'duration-1000');
      setTimeout(() => {
        element.classList.remove('bg-indigo-500', 'bg-opacity-30');
      }, 2000);
    }
  };

  const handleSubmitDisplayname = async () => {
    if (newDisplayName.length > 2 || newDisplayName.length === 0) {
      if (newDisplayName.length === 0) {
        setNewDisplayName(userObj.displayName);
      }
      const ref = doc(db, `users`, auth.currentUser.uid);
      updateDoc(ref, {
        displayName: newDisplayName,
        nameChanged: true,
      });
      const newObj = jukeboxUserObj;
      newObj.displayName = newDisplayName;
      newObj.nameChanged = true;
      setJukeboxUserObj(newObj);
      setDisplayNameOpen(false);
      setIsOpen(!isOpen);
      // now send this request to dj
      sendThisPickToDJ(currentRequestDetails);
    } else {
      alert("new name needs to be longer");
    }
  };

  const handleUpdateDisplayname = async (event) => {
    let value = event.target.value;
    if (value.length > 2) {
      setNewDisplayName(value);
    }
  };

  const pickTrack = async (event, track, i) => {
    setRequestedTrack(track);
    const ii = jukebox.findIndex((item) => item.id === track.id);
    setShowVideoPlayback(false);
    setShowTrackForm(false);
    setVideoId(track.youTubeId);
    setCurrentPlayingTrackIndex(ii);

    if (ii >= jukebox.length - 1) {
      setNextPlayingTrackIndex(1);
    } else {
      setNextPlayingTrackIndex(ii + 1);
    }

    setTimeout(() => {
      setShowVideoPlayback(true);
    }, 300);
  };

  const getCurrentDisplayName = async () => {
    try {
      const requestCurrentIdRef = doc(db, "users", auth.currentUser.uid);
      const user = await getDoc(requestCurrentIdRef, requestCurrentIdRef);
      return user.displayName;
    } catch (err) {
      console.error("error:", err);
    }
  };

  const sendThisPickToDJ = async (item) => {
    let prepareOpenRequest = new Promise(function (resolve, reject) {
      resolve("Promise resolved");
    });

    prepareOpenRequest
      .then(async () => {
        try {
          const requestCurrentIdRef = doc(db, "users", auth.currentUser.uid);
          const user = await getDoc(requestCurrentIdRef, requestCurrentIdRef);
          if (user.exists()) {
            const displayName = user.data().displayName;
            return displayName;
          }
        } catch (err) {
          console.error("error:", err);
        }
      })
      .then(async (displayName) => {
        const requestSongRef4 = collection(
          db,
          "users",
          auth.currentUser.uid,
          "djchats"
        );
        if (newDisplayName !== "") displayName = newDisplayName;
        try {
          const newprod = await addDoc(requestSongRef4, {
            request: item,
            createdAt: serverTimestamp(),
            user: displayName,
            uid: auth.currentUser.uid,
          });
          setDJChatId(newprod.id);
          return newprod;
        } catch (error) {
          console.error("Error adding document: ", error);
        }
      })
      .then(async (newprod) => {
        const requestSongRef5 = collection(
          db,
          "users",
          auth.currentUser.uid,
          "djchats",
          newprod.id,
          "requesters"
        );
        try {
          await addDoc(requestSongRef5, {
            createdAt: serverTimestamp(),
            user: auth.currentUser.displayName || auth.currentUser.email,
            uid: auth.currentUser.uid,
          });
          return newprod;
        } catch (error) {
          console.error("Error adding document: ", error);
        }
      })
      .then(async (newprod) => {
        const requestSongRef5 = collection(
          db,
          "users",
          auth.currentUser.uid,
          "djchats",
          newprod.id,
          "requesters"
        );
        try {
          await addDoc(requestSongRef5, {
            createdAt: serverTimestamp(),
            user: auth.currentUser.displayName || auth.currentUser.email,
            uid: auth.currentUser.uid,
          });
          return newprod;
        } catch (error) {
          console.error("Error adding document: ", error);
        }
      })
      .then(async (newprod) => {
        const requestSongRef6 = collection(
          db,
          "users",
          auth.currentUser.uid,
          "requests"
        );
        try {
          await addDoc(requestSongRef6, {
            createdAt: serverTimestamp(),
            djchatId: newprod.id,
          });
        } catch (error) {
          console.error("Error adding document: ", error);
        }
      });
  };

  const setRequestedTrackSetter = (item) => {
    setRequestedTrack(item);
  };

  const loadAutoPlaylist = (id, tracks, pn) => {
    setPlaylistId(id);
    setPlaylistName(pn);
    setGroupedTracks(groupTracksByGenre(tracks));
    setJukebox(tracks);
    setOriginalJukebox(tracks);
  };

  const handleDragStart = (e, item) => {
    setDraggingItem(item);
    e.dataTransfer.setData("text/plain", "");
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetItem, i) => {
    if (!draggingItem) return;

    const currentIndex = jukebox.indexOf(draggingItem);
    const targetIndex = jukebox.indexOf(targetItem);

    let p = jukebox;
    if (currentIndex !== -1 && targetIndex !== -1) {
      p.splice(currentIndex, 1);
      p.splice(targetIndex, 0, draggingItem);
      setJukebox(p);
    }
    setTimeout(() => {
      if (
        currentIndex > currentPlayingTrackIndex &&
        targetIndex < currentPlayingTrackIndex
      ) {
        setCurrentPlayingTrackIndex(currentPlayingTrackIndex + 1);

        if (currentPlayingTrackIndex + 1 >= jukebox.length - 1) {
          setNextPlayingTrackIndex(1);
        } else {
          setNextPlayingTrackIndex(currentPlayingTrackIndex + 2);
        }
      } else if (
        currentIndex < currentPlayingTrackIndex &&
        targetIndex > currentPlayingTrackIndex
      ) {
        setCurrentPlayingTrackIndex(currentPlayingTrackIndex - 1);

        if (currentPlayingTrackIndex - 1 <= 0) {
          setNextPlayingTrackIndex(1);
        } else {
          setNextPlayingTrackIndex(currentPlayingTrackIndex);
        }
      }
      forceUpdate();
    }, 300);
  };

  useEffect(() => {
    const getChannel = async () => {
      const getDefaultPlaylist = async (plId) => {
        let prepareList = new Promise(function (resolve, reject) {
          resolve("Promise resolved");
        });

        prepareList.then(async () => {});
        const listRef = collection(db, "playlists", plId, "tracks");
        const queryTracks = query(listRef, orderBy("ordinal"));
        const unsubscribe = onSnapshot(queryTracks, (snapshot) => {
          let playlist = [];
          let trackDocRef;
          snapshot.forEach(async (docItem) => {
            trackDocRef = doc(
              db,
              "playlists",
              plId,
              "tracks",
              docItem.data().id
            );
            const docSnap = await getDoc(trackDocRef);
            if (docSnap.exists()) {
              playlist.push({
                id: docSnap.id,
                track: docSnap.data().track,
                genre: docSnap.data().genre,
                artist: docSnap.data().artist,
                coverart: docSnap.data().coverart,
                url: docSnap.data().url,
                youTubeId: docSnap.data().youTubeId,
                filename: docSnap.data().filename,
              });
            }
          });

          setTimeout(() => {
            setGroupedTracks(groupTracksByGenre(playlist));
            setJukebox(playlist);
            setOriginalJukebox(playlist);
          }, 1000);
        });
        return () => unsubscribe();
      };

      if (accountName) {
        const docRef2 = doc(db, "clients", accountName);
        const docSnap2 = await getDoc(docRef2);
        if (docSnap2.exists()) {
          setDefaultPlaylist(docSnap2.data().defaultPlaylist || "");
          setPlaylistName(docSnap2.data().defaultPlaylist || "");
          // setAvatarImage(docSnap2.data().avatarImage || "");

          const idx = jukeboxList.findIndex(
            (item) => item.playlistName === docSnap2.data().defaultPlaylist
          );

          if (idx !== -1) {
            const plId = jukeboxList[idx].id;
            setPlaylistId(plId);
            getDefaultPlaylist(plId);
          }
        }
      }
    };
    getChannel();
  }, [accountName, jukeboxList]);

  useEffect(() => {
    // update this DJ user with current track details muuzboxCurrentSong
    // if(!currentSong?.filename) currentSong.filename = "";

    // console.log('currentSong', currentSong);
    if (currentSong) {
      let cs = {
        id: currentSong.id || "",
        artist: currentSong.artist || "",
        track: currentSong.track || "",
        url: currentSong.url,
        filename: currentSong.filename || "",
        genre: nextSong.genre || "",
        nmlgenre: nextSong.nmlgenre || "",
        coverart: currentSong.coverart || "",
        youTubeId: currentSong.youTubeId || "",
      };

      const ref = doc(
        db,
        `users`,
        auth.currentUser.uid,
        "currentSong",
        "CURRENTSONG"
      );
      setDoc(ref, {
        muuzboxCurrentSong: cs,
        updatedAt: serverTimestamp(),
      });

      if (nextSong) {
        let ns = {
          id: nextSong.id || "",
          artist: nextSong.artist || "",
          track: nextSong.track || "",
          url: nextSong.url,
          filename: nextSong.filename || "",
          genre: nextSong.genre || "",
          nmlgenre: nextSong.nmlgenre || "",
          coverart: nextSong.coverart || "",
          youTubeId: nextSong.youTubeId || "",
        };

        const ref2 = doc(
          db,
          `users`,
          auth.currentUser.uid,
          "nextSong",
          "NEXTSONG"
        );
        setDoc(ref2, {
          muuzboxNextSong: ns,
          updatedAt: serverTimestamp(),
        });
      }
    }
  }, [currentSong, nextSong, playlistId, previousCurrentSongId]);

  const handleVideoPlayback = (e, track, i) => {
    e.preventDefault();
    const originIdx = i;
    if (i === null) {
      i = track.ordinal;
    }

    // whatever is next in jukebox unless track is last track, therefore i must by last index
    if (i >= jukebox.length - 1) {
      setNextSong(jukebox[1]);
    } else {
      // console.log("*ns track", track);

      let nsIdx = 1;
      while (
        jukebox[i + nsIdx].queued === true ||
        jukebox[i + nsIdx].skip === true
      ) {
        nsIdx++;
      }

      // console.log("*ns nextTrack", jukebox[i + nsIdx]);
      setNextSong(jukebox[i + nsIdx]); // is this a requested song? Lets now only put non requested songs as next song
    }

    setCurrentSong(track);
    // Only remove from pending if track is actually playable (has media)
    if (track.youTubeId || track.url) {
      const op = [];
      op.push(track);
      setOldPending(op); // remove from pending collection
    }

    if (track.youTubeId) {
      // must first send message to audio player to stop before hiding it
      const pause = { pause: true };
      setMessage(JSON.stringify(pause));

      setTimeout(() => {
        setShowMP3Playback(false);
        setShowVideoPlayback(false);
        setShowTrackForm(false);
        setVideoId(track.youTubeId);
        setCurrentPlayingTrackIndex(i);

        if (i >= jukebox.length - 1) {
          setNextPlayingTrackIndex(1);
        } else {
          setNextPlayingTrackIndex(i + 1);
        }

        setTimeout(() => {
          setShowVideoPlayback(true);
        }, 300);
      }, 300);
    } else if (track.url) {
      setStopAudio(false);

      if (originIdx !== 0) {
        const changeCurTrackIndex = { curTrack: originIdx };
        setMessage(JSON.stringify(changeCurTrackIndex));
      } else {
        const rand = Math.floor(Math.random() * 1000);
        const changeCurTrackIndex = { curTrackZero: rand };
        setMessage(JSON.stringify(changeCurTrackIndex));
      }

      setShowVideoPlayback(false);
      setShowTrackForm(false);
      setTrackList(jukebox);
      setCurrentPlayingTrackIndex(originIdx);
      if (originIdx + 1 >= jukebox.length - 1) {
        setNextPlayingTrackIndex(1);
      } else {
        setNextPlayingTrackIndex(originIdx + 1);
      }
      setTimeout(() => {
        setShowMP3Playback(true);
      }, 300);
    } else {
      // console.log("this track as no media attached to it that can be played");
    }
  };

  const handleEditTrack = (e, track) => {
    e.preventDefault();
    // track.id
    setTrackId(track.id);
    setTrack(track.track);
    setArtist(track.artist);
    setGenre(track.genre);
    setUrl(track.url);
    setYouTubeId(track.youTubeId);
    setCoverart(track.coverart);

    setShowVideoPlayback(false);
    setShowTrackForm(true);
  };

  const handleSaveTrack = async () => {
    try {
      // Update the track in Firebase
      const trackRef = doc(db, "playlists", playlistId, "tracks", trackId);
      await updateDoc(trackRef, {
        track: track,
        artist: artist,
        genre: genre,
      });

      // Update the local jukebox array
      const updatedJukebox = jukebox.map((item) => {
        if (item.id === trackId) {
          return {
            ...item,
            track: track,
            artist: artist,
            genre: genre,
          };
        }
        return item;
      });

      setJukebox(updatedJukebox);

      // Update grouped tracks as well
      setGroupedTracks(groupTracksByGenre(updatedJukebox));

      // Close the modal
      setShowTrackForm(false);

      // Clear the form state
      setTrackId(null);
      setTrack(null);
      setArtist(null);
      setGenre(null);

      alert("Track details updated successfully!");
    } catch (error) {
      console.error("Error updating track:", error);
      alert("Failed to update track details. Please try again.");
    }
  };

  const playNextTrack = () => {
    setShowVideoPlayback(false);
    const i = currentPlayingTrackIndex;
    let originIdx = currentPlayingTrackIndex + 1;
    let track;
    let nextTrack;
    if (i + 1 >= jukebox.length) {
      setShowMP3Playback(false);
      originIdx = 0;
      setCurrentPlayingTrackIndex(0);
      setNextPlayingTrackIndex(1);
      initialisePlaylist().then(() => {
        track = jukebox[0];
        nextTrack = jukebox[1];
      });
    } else {
      setCurrentPlayingTrackIndex(i + 1);

      // actually this is where to determine if track is to be skipped
      let idx = 1;
      while (jukebox[i + idx].skip === true) {
        idx++;
      }
      track = jukebox[i + idx];
      originIdx = i + idx;
      let nsIdx = idx + 1;

      // check if there are queued pending tracks
      // check if track is skippable due to down votes also
      while (jukebox[i + nsIdx] && jukebox[i + nsIdx].queued === true) {
        nsIdx++;
      }

      setNextPlayingTrackIndex(i + nsIdx);
      nextTrack = jukebox[i + nsIdx];

      // console.log("*&* *ns track", track);
      // console.log("*&*  *ns nextTrack", nextTrack);
    }

    setCurrentSong(track);
    setNextSong(nextTrack); // is this a requested song. lets only put non requested songs as next song

    //
    // find this track in jukebox and park queued as false
    if (track) {
      const jb = jukebox;
      const idx = jb.findIndex((item) => item.id === track.id);
      if (idx !== -1) {
        jb[idx].queued = false;
        setJukebox(jb);
      }
      // Only remove from pending if track is actually playable (has media)
      if (track.youTubeId || track.url) {
        const op = [];
        op.push(track);
        setOldPending(op); // remove from pending collection
      }
    } else {
      // console.log('no track data, so initialise please')
      setShowMP3Playback(false);
      originIdx = 0;
      setCurrentPlayingTrackIndex(0);
      setNextPlayingTrackIndex(1);
      initialisePlaylist().then(() => {
        track = jukebox[0];
        nextTrack = jukebox[1];
        setCurrentSong(track);
        setNextSong(nextTrack); // is this a requested song. lets only put non requested songs as next song
      });
    }

    console.log("track", track);
    if (track.youTubeId) {
      setShowMP3Playback(false);
      setVideoId(track.youTubeId);
      setTimeout(() => {
        setShowVideoPlayback(true);
      }, 300);
    } else if (track.url) {
      // console.log("going for the local mp3 player");
      setStopAudio(false);
      const changeCurTrackIndex = { curTrack: originIdx };
      setMessage(JSON.stringify(changeCurTrackIndex));
      setShowVideoPlayback(false);
      setShowTrackForm(false);
      setTrackList(jukebox);
      setCurrentPlayingTrackIndex(originIdx);
      setTimeout(() => {
        setShowMP3Playback(true);
      }, 300);
    } else {
      // console.log("this track as no media attached to it that can be played");
    }
  };

  const initialisePlaylist = async () => {
    // before anything, clear the pending playlist out
    const collectionRef = collection(
      db,
      "users",
      auth.currentUser.uid,
      "pendingList"
    ); // Change to your collection name

    const querySnapshot = await getDocs(collectionRef);
    const batch = writeBatch(db);

    querySnapshot.forEach((doc) => {
      batch.delete(doc.ref);
    });

    await batch.commit();
    // console.log("Documents deleted successfully");

    // let playlist = [];
    // const playlistRef = collection(db, "playlists", playlistId, "tracks");
    // const queryList = query(playlistRef, orderBy("ordinal")); //, where("createdAt", "<", serverTimestamp()), orderBy("createdAt"));
    // const unsuscribe = onSnapshot(queryList, (snapshot) => {
    //   playlist = [];
    //   snapshot.forEach(async (docItem) => {
    //     const trackDocRef = doc(
    //       db,
    //       "playlists",
    //       playlistId,
    //       "tracks",
    //       docItem.data().id
    //     );
    //     const docSnap = await getDoc(trackDocRef);
    //     if (docSnap.exists()) {
    //       playlist.push({
    //         id: docSnap.id,
    //         track: docSnap.data().track,
    //         genre: docSnap.data().genre,
    //         artist: docSnap.data().artist,
    //         coverart: docSnap.data().coverart,
    //         url: docSnap.data().url,
    //         youTubeId: docSnap.data().youTubeId,
    //         filename: docSnap.data().filename,
    //       });
    //     }
    //   });
    // });

    // return () => unsuscribe();
  };

  return (
    <>
      <div className="flex flex-col flex-auto sm:items-stretch md:item-stretch jukebox-panel eebbzz admin-template">
        {/* DJ / User details */}
        <div className="flex flex-row text-white items-center pb-3 font-black">
          <div class="flex justify-center h-16 w-16 md:h-16 md:w-16 max-h-16 max-w-16 mx-0.5 my-0.5 rounded-full border overflow-hidden text-center items-center ">
            <div>
              <img
                src={jukeboxUserObj.photoURL}
                alt={jukeboxUserObj.displayNamel}
                title={jukeboxUserObj.displayName}
              />
            </div>
          </div>

          <div className="text-sm mx-2 my-1">
            {jukeboxUserObj.displayName}
            <p className="text-gray-100 text-base">Member</p>
          </div>
        </div>
        <div className="text-white text-center font-black text-xs uppercase pb-2">
          Playlists
        </div>

        <div className="flex flex-col flex-auto flex-shrink-0 rounded-2xl bg-gray-100 h-full p-4 panel-fade">
          <div
            className={`flex flex-row items-center h-16 rounded-xl bg-white px-4 h-24 m-12 panel-fade text-enter-fit ${
              inputFocus === true ? "text-enter-full" : ""
            }`}
            style={{
              position: "absolute",
              bottom: "9rem",
              left: "0",
              margin: "1.5rem",
            }}
          >
            {/* audio playback */}
            {showAudioPlayback && (
              <div className={`flex flex-row justify-center items-center`}>
                <Player
                  trackList={siteConfig.initialTrack}
                  clearList={siteConfig.initialTrack}
                  jukebox={jukebox}
                />
              </div>
            )}

            {/* audio playback */}
            {showMP3Playback && (
              <div className="pl-4 flex items-center w-full">
                <div className="editplayer">
                  {/* <div>{jukebox[currentPlayingTrackIndex].track}</div> */}
                  <div className="flex flex-row justify-center items-center">
                    <Player4
                      trackList={jukebox}
                      jukebox={jukebox}
                      currentPlayingTrackIndex={currentPlayingTrackIndex}
                      playNextTrack={playNextTrack}
                      stopAudio={stopAudio}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* stream playback */}
            {showVideoPlayback && (
              <div className={`flex flex-row justify-center items-center`}>
                <VideoPlayback4
                  videoId={videoId}
                  playNextTrack={playNextTrack}
                  trackArtist={jukebox[currentPlayingTrackIndex].artist || ""}
                  trackTitle={jukebox[currentPlayingTrackIndex].track || ""}
                  // deck={1}
                  // setCurrentDeck={setCurrentDeck}
                />
              </div>
            )}
            {/* {showVideoPlayback2 && (
              <div className={`flex flex-row justify-center items-center  ${
                currentDeck === 2 ? "invisible" : ""
              } `}>
                <VideoPlayback4
                  videoId={videoId}
                  playNextTrack={playNextTrack}
                  trackArtist={jukebox[currentPlayingTrackIndex].artist}
                  trackTitle={jukebox[currentPlayingTrackIndex].track}
                  deck={2}
                  setCurrentDeck={setCurrentDeck}
                />
              </div>
            )} */}
          </div>

          <div className="flex flex-row autoplay-content">
            <div className="flex flex-col overflow-x-auto mb-4 scrollable-section no-scrollbar">
              <div className="flex flex-row  h-full no-scrollbar">
                <div className="muuzbox-list">
                  {displayNameOpen && (
                    <div className="bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 muuz-displayname-panel">
                      <div>
                        CURRENT DISPLAY NAME
                        <input
                          placeholder={userObj.displayName}
                          type="text"
                          name="newdisplayname"
                          id="newdisplayname"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleSubmitDisplayname(e);
                          }}
                          onChange={handleUpdateDisplayname}
                          className="flex w-full text-gray-800 dark:text-gray-800 border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 h-20"
                        />
                        <button
                          onClick={(e) => {
                            setDisplayNameOpen(false);
                            handleSubmitDisplayname(e);
                          }}
                          className="text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700 muuzmenuitem"
                        >
                          update your name to continue
                        </button>
                      </div>
                    </div>
                  )}
                  {isOpen && (
                    <div className="bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 muuz-confirm-panel">
                      <div
                        className="py-2 text-sm text-gray-700 dark:text-gray-200"
                        aria-labelledby="dropdownDefaultButton"
                      >
                        <div className="text-center">
                          <div
                            onClick={() => {
                              setIsOpen(!isOpen);
                            }}
                            class="muuzbox-section-button"
                          >
                            <div
                              id="notifyMuuzbox-close"
                              class="section-close muuzbox-close rounded"
                            ></div>
                          </div>

                          <button
                            onClick={() => {
                              setIsOpen(!isOpen);
                            }}
                            className="block w-full text-center px-4 py-2 hover:bg-gray-600 dark:hover:bg-gray-600 dark:hover:text-white muuzmenuitem"
                          >
                            <div>
                              <strong>{requestedTrack.artist}</strong>
                            </div>
                            <div>{requestedTrack.track}</div>
                          </button>
                          <div className="block w-full text-xl text-center text-red-800">
                            DJ OBAH has been informed of your request
                          </div>
                        </div>

                        {messages && (
                          <>
                            {messages.map((message, i) => (
                              <div
                                className="flex flex-row items-center hover:bg-gray-100 rounded-xl p-2"
                                key={i}
                              >
                                <div className="flex items-center justify-center h-12 w-12 rounded-full border overflow-hidden bg-indigo-500 flex-shrink-0">
                                  <img
                                    src={avatars[message.uid]?.photoURL}
                                    alt={avatars[message.uid]?.displayName}
                                  />
                                </div>
                                <div className="ml-2 text-lg font-semibold">
                                  {message.text}
                                </div>
                              </div>
                            ))}
                          </>
                        )}

                        {messages.length === 0 && (
                          <div class="muuzbox-loader-logo-sm fadeIn">
                            <img
                              src="img/muuzbox-logo.png"
                              alt="Muuzbox logo"
                            />
                            <div class="muuzbox-loader-blob"></div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Track Edit Modal */}
                  {showTrackForm && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div className="bg-white rounded-lg shadow-xl w-96 p-6">
                        <div className="flex justify-between items-center mb-4">
                          <h2 className="text-xl font-bold text-gray-800">
                            Edit Track Details
                          </h2>
                          <button
                            onClick={() => setShowTrackForm(false)}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <svg
                              className="w-6 h-6"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Track Name
                            </label>
                            <input
                              type="text"
                              value={track || ""}
                              onChange={(e) => setTrack(e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              placeholder="Enter track name"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Artist
                            </label>
                            <input
                              type="text"
                              value={artist || ""}
                              onChange={(e) => setArtist(e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              placeholder="Enter artist name"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Genre
                            </label>
                            <input
                              type="text"
                              value={genre || ""}
                              onChange={(e) => setGenre(e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              placeholder="Enter genre"
                            />
                          </div>
                        </div>

                        <div className="flex justify-end space-x-3 mt-6">
                          <button
                            onClick={() => setShowTrackForm(false)}
                            className="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md focus:outline-none"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => handleSaveTrack()}
                            className="px-4 py-2 text-white bg-indigo-500 hover:bg-indigo-600 rounded-md focus:outline-none"
                          >
                            Save Changes
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  <h2 className="text-white">AUTO PLAY [{playlistName}]</h2>
                  <div className="text-white text-xs mb-2">
                    Votes last updated: {lastVoteUpdate.toLocaleTimeString()}
                  </div>
                  
                  <AccordionList
                    data={groupedTracks}
                    setRequestedTrack={setRequestedTrackSetter}
                    pickTrack={pickTrack}
                    listTitle="Playlist"
                    mode={"dark"}
                  />
                  
                  {/* Search and Alphabetical Toggle */}
                  <div className="flex flex-col space-y-2 mb-4 mt-4">
                    {/* Search Bar */}
                    <div className="relative">
                      <input
                        ref={searchInputRef}
                        type="text"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        onKeyDown={handleSearchKeyDown}
                        placeholder="Search by track or artist..."
                        className="w-full px-4 py-2 pr-10 text-white bg-gray-800 border border-gray-600 rounded-lg focus:outline-none focus:border-indigo-500"
                      />
                      {searchTerm && (
                        <button
                          onClick={() => {
                            setSearchTerm('');
                            setSearchResults([]);
                            setCurrentSearchIndex(-1);
                          }}
                          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      )}
                    </div>
                    
                    {/* Search Results Count */}
                    {searchTerm && (
                      <div className="text-sm text-gray-400">
                        {searchResults.length > 0 ? (
                          <>Found {searchResults.length} results. Press Tab to navigate.</>
                        ) : (
                          <>No results found</>
                        )}
                      </div>
                    )}
                    
                    {/* Alphabetical Toggle Button */}
                    <button
                      onClick={toggleAlphabetical}
                      className={`w-1/2 flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                        isAlphabetical 
                          ? 'bg-indigo-600 text-white' 
                          : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                      }`}
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
                      </svg>
                      <span>{isAlphabetical ? 'Sorted A-Z' : 'Sort A-Z'}</span>
                    </button>
                  </div>

                  <div className="sortable-list">
                    {jukebox.map((item, i) => (
                      <div
                        key={i}
                        ref={el => trackRefs.current[item.id] = el}
                        className={`item ${
                          item === draggingItem ? "dragging" : ""
                        } ${
                          searchResults.length > 0 && searchResults[currentSearchIndex]?.id === item.id 
                            ? "border-2 border-indigo-500 bg-indigo-500 bg-opacity-10 rounded-lg" 
                            : ""
                        }`}
                        draggable="true"
                        onDragStart={(e) => handleDragStart(e, item)}
                        onDragEnd={handleDragEnd}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, item, i)}
                      >
                        <div
                          className="flex items-center py-4 px-3 jukebox-divider"
                          key={i}
                          onClick={(event) => {
                            setRequestedTrack(item);
                          }}
                        >
                          <span className="text-white text-lg font-black font-medium">
                            {i + 1}.
                          </span>
                          <img
                            className=" rounded-full object-cover mr-3 ml-3"
                            src={item.coverart}
                            style={{ width: "48px", height: "48px" }}
                            alt={item.track}
                          />
                          <div
                            className="flex-1 text-left"
                            style={{ width: "50%" }}
                          >
                            <h3 className="text-lg font-medium text-white overflow-hidden">
                              {item.artist}
                            </h3>
                            <p className="text-white text-base">
                              {item.track}{" "}
                            </p>
                            <p className="text-white text-base">
                              {item.genre}{" "}
                              {item.queued && (
                                <>
                                  <span className="text-yellow-800">
                                    {" "}
                                    : REQUESTED
                                  </span>
                                </>
                              )}
                              {item.skip && (
                                <>
                                  <span className="text-yellow-800">
                                    {" "}
                                    : SKIP
                                  </span>
                                </>
                              )}
                            </p>
                          </div>
                          <div className="flex flex-col items-center mr-4">
                            {/* Vote display */}
                            <div className="flex items-center mb-1">
                              <svg
                                width="16px"
                                height="16px"
                                viewBox="0 0 24 24"
                                fill={
                                  upObj[item.id] && upObj[item.id] > 0
                                    ? "#0000FF"
                                    : "#FFFFFF"
                                }
                                fillOpacity={
                                  upObj[item.id] && upObj[item.id] > 0
                                    ? "1"
                                    : "0.3"
                                }
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.99997 20H17.1919C17.9865 20 18.7058 19.5296 19.0243 18.8016L21.8323 12.3833C21.9429 12.1305 22 11.8576 22 11.5816V11C22 9.89543 21.1045 9 20 9H13.5L14.7066 4.5757C14.8772 3.95023 14.5826 3.2913 14.0027 3.00136V3.00136C13.4204 2.7102 12.7134 2.87256 12.3164 3.3886L8.41472 8.46082C8.14579 8.81044 7.99997 9.23915 7.99997 9.68024V20ZM7.99997 20H2V10H7.99997V20Z"
                                  stroke="#FFFFFF"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span className="text-white text-sm ml-1">
                                {upObj[item.id] || 0}
                              </span>
                            </div>
                            <div className="flex items-center">
                              <svg
                                width="16px"
                                height="16px"
                                viewBox="0 0 24 24"
                                fill={
                                  downObj[item.id] && downObj[item.id] > 0
                                    ? "#FF0000"
                                    : "#FFFFFF"
                                }
                                fillOpacity={
                                  downObj[item.id] && downObj[item.id] > 0
                                    ? "1"
                                    : "0.3"
                                }
                                xmlns="http://www.w3.org/2000/svg"
                                transform="scale(-1, 1)"
                              >
                                <path
                                  d="M7.99997 4H17.1919C17.9865 4 18.7058 4.47039 19.0243 5.19836L21.8323 11.6167C21.9429 11.8695 22 12.1424 22 12.4184V13C22 14.1046 21.1045 15 20 15H13.5L14.7066 19.4243C14.8772 20.0498 14.5826 20.7087 14.0027 20.9986V20.9986C13.4204 21.2898 12.7134 21.1274 12.3164 20.6114L8.41472 15.5392C8.14579 15.1896 7.99997 14.7608 7.99997 14.3198V14M7.99997 4H2V14H7.99997M7.99997 4V14"
                                  stroke="#FFFFFF"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span className="text-white text-sm ml-1">
                                {downObj[item.id] || 0}
                              </span>
                            </div>
                          </div>
                          <div>
                            {/* play button */}
                            <button
                              onClick={(event) =>
                                handleVideoPlayback(event, item, i)
                              }
                              className={`flex items-center justify-center nodecor  ${
                                i === currentPlayingTrackIndex
                                  ? "bg-red-500 hover:bg-red-600"
                                  : "bg-indigo-500 hover:bg-indigo-600"
                              }   rounded-md text-white px-4 py-1  w-6 h-6 mt-4 mr-2`}
                            >
                              <span className="ml-0">
                                <svg
                                  alt={"edit " + item.track}
                                  title={"edit " + item.track}
                                  className="w-4 h-4 -mt-px text-white"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M21.4086 9.35258C23.5305 10.5065 23.5305 13.4935 21.4086 14.6474L8.59662 21.6145C6.53435 22.736 4 21.2763 4 18.9671L4 5.0329C4 2.72368 6.53435 1.26402 8.59661 2.38548L21.4086 9.35258Z"
                                    fill="#FFFFFF"
                                  />
                                </svg>
                              </span>
                            </button>

                            {/* edit button */}
                            <button
                              onClick={(event) => handleEditTrack(event, item)}
                              className="flex items-center justify-center nodecor bg-indigo-500 hover:bg-indigo-600 rounded-md text-white px-4 py-1  w-6 h-6 mt-4 mr-2"
                            >
                              <span className="ml-0">
                                <svg
                                  alt={"edit " + item.track}
                                  title={"edit " + item.track}
                                  className="w-4 h-4 -mt-px text-white"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M20.8477 1.87868C19.6761 0.707109 17.7766 0.707105 16.605 1.87868L2.44744 16.0363C2.02864 16.4551 1.74317 16.9885 1.62702 17.5692L1.03995 20.5046C0.760062 21.904 1.9939 23.1379 3.39334 22.858L6.32868 22.2709C6.90945 22.1548 7.44285 21.8693 7.86165 21.4505L22.0192 7.29289C23.1908 6.12132 23.1908 4.22183 22.0192 3.05025L20.8477 1.87868ZM18.0192 3.29289C18.4098 2.90237 19.0429 2.90237 19.4335 3.29289L20.605 4.46447C20.9956 4.85499 20.9956 5.48815 20.605 5.87868L17.9334 8.55027L15.3477 5.96448L18.0192 3.29289ZM13.9334 7.3787L3.86165 17.4505C3.72205 17.5901 3.6269 17.7679 3.58818 17.9615L3.00111 20.8968L5.93645 20.3097C6.13004 20.271 6.30784 20.1759 6.44744 20.0363L16.5192 9.96448L13.9334 7.3787Z"
                                    fill="#FFFFFF"
                                  />
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col overflow-x-auto mb-4 scrollable-section">
              <div className="flex flex-row  h-full">
                <div className="muuzbox-shop text-white p-20">
                  <JukeboxRequests loadAutoPlaylist={loadAutoPlaylist} />
                  <ul>
                    <li>
                      <h2>MOOD INSIGHTS</h2>
                      <MoodDashboard clientObj={clientObj} />
                    </li>
                    <li>
                      <h2>THIS IS OBAH</h2>
                      <div className="rounded-2xl bg-gray-100 h-full p-4 panel-fade">
                        <img
                          src="https://thisisobah.com/img/icons/obah-entertainment.png"
                          title="This Is Obah Entertainment"
                          alt="This Is Obah Entertainment"
                        />
                      </div>
                    </li>
                    <li>
                      <h2>Muuzbox Merch</h2>
                      <div className="rounded-2xl bg-gray-100 h-full p-4 panel-fade">
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/chatbout001.appspot.com/o/users%2FBs7gqBrNUtMBmM7jgEyGmCKtSNl1%2Ffiles%2Fkali-zing-shirt.png?alt=media&token=f3a310a5-ebf8-401f-9d32-917032bc8c44"
                          title="Muuzbox Merch"
                          alt="Muuzbox Merch"
                        />
                      </div>
                    </li>
                    <li>
                      <h2>CTFO MUSIC</h2>
                      <div className="rounded-2xl bg-gray-100 h-full p-4 panel-fade">
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/chatbout001.appspot.com/o/users%2FL8s7DzpsAvabSIyNx0xxeuhuryM2%2Ffiles%2FCTFO-Music-Logo.png?alt=media&token=b0900a88-84e0-4471-9c27-b038ab1d1995"
                          title="ctfo music"
                          alt="ctfo music"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
